export enum AnalyticsBaseOrderDtoKeys {
  locationId = 'locationId',
  bookingType = 'bookingType',
  compositionTypeId = 'compositionTypeId',
}

export class AnalyticsBaseOrderDto {
  locationId: string;
  bookingType: number;
  compositionTypeId: string;

  constructor(locationId: string, bookingType: number, compositionTypeId: string) {
    this.locationId = locationId;
    this.bookingType = bookingType;
    this.compositionTypeId = compositionTypeId;
  }
}
